import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';
import { useContext } from 'react';
import { ProLayoutContext } from '../../../context/ProLayoutContext';

var _map = [576, 768, 992, 1200].map(function (bp) {
  return "@media (min-width: ".concat(bp, "px)");
}),
    _map2 = _slicedToArray(_map, 4),
    sm = _map2[0],
    md = _map2[1],
    lg = _map2[2],
    xl = _map2[3];

var genPageContainerStyle = function genPageContainerStyle(token) {
  var _extraContent, _token$componentCls;

  return _defineProperty({}, token.componentCls, (_token$componentCls = {
    position: 'relative',
    '&-layout-has-margin': {
      marginBlock: token.marginBlockPageContainerContent,
      marginInline: -token.marginInlinePageContainerContent
    },
    '&-children-content': {
      marginBlock: token.marginBlockPageContainerContent,
      marginInline: token.marginInlinePageContainerContent
    },
    '&-affix': _defineProperty({}, "".concat(token.antCls, "-affix"), _defineProperty({}, "".concat(token.componentCls, "-warp"), {
      backgroundColor: token.colorBgPageContainerFixed,
      boxShadow: '0 2px 8px #f0f1f2'
    }))
  }, _defineProperty(_token$componentCls, '& &-warp-page-header', _defineProperty({
    marginBlockEnd: token.marginBlockPageContainerContent / 2,
    paddingInlineStart: 40,
    paddingInlineEnd: 40
  }, "& ~ ".concat(token.proComponentsCls, "-grid-content"), _defineProperty({}, "".concat(token.proComponentsCls, "-page-container-children-content"), {
    marginBlock: token.marginBlockPageContainerContent / 3
  }))), _defineProperty(_token$componentCls, '&-detail', _defineProperty({
    display: 'flex'
  }, sm, {
    display: 'block'
  })), _defineProperty(_token$componentCls, '&-main', {
    width: '100%'
  }), _defineProperty(_token$componentCls, '&-row', _defineProperty({
    display: 'flex',
    width: '100%'
  }, md, {
    display: 'block'
  })), _defineProperty(_token$componentCls, '&-content', {
    flex: 'auto',
    width: '100%'
  }), _defineProperty(_token$componentCls, '&-extraContent', (_extraContent = {
    flex: '0 1 auto',
    minWidth: '242px',
    marginInlineStart: 88,
    textAlign: 'end'
  }, _defineProperty(_extraContent, sm, {
    marginInlineStart: 0
  }), _defineProperty(_extraContent, md, {
    marginInlineStart: 0,
    textAlign: 'start'
  }), _defineProperty(_extraContent, lg, {
    marginInlineStart: 20
  }), _defineProperty(_extraContent, xl, {
    marginInlineStart: 44
  }), _extraContent)), _token$componentCls));
};

export function useStyle(prefixCls) {
  var _useContext = useContext(ProLayoutContext),
      pageContainer = _useContext.pageContainer;

  return useAntdStyle('page-container', function (token) {
    var proCardToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    }, pageContainer);

    return [genPageContainerStyle(proCardToken)];
  });
}